const parseAsFloat = (value) => {
  const returnValue = value && parseFloat(value.toString().replace(",", "."));

  return returnValue && !Number.isNaN(returnValue) ? returnValue : value;
};

export default parseAsFloat;
